import Component from './component';

export interface Props {
	title: string;
}

Component.defaultProps = {};
export default Component;
